import {
  BillIcon,
  CashIcon,
  PettyCashBudgetIcon,
} from '@razorpay/blade/components';
import React from 'react';
import { CtcBreakdownData } from '../types';
import ComponentContainer from './generics/ComponentContainer';
import ComponentHeader from './generics/ComponentHeader';
import ComponentSection from './generics/ComponentSection';
import ComponentSectionItem from './generics/ComponentSectionItem';
import ComponentTable from './generics/CtcBreakdownTable';
import { usePayDetails } from '../context/PayDetailsContext';

const CtcComponent = () => {
  const { compensationData } = usePayDetails();
  const ctcData: CtcBreakdownData = compensationData.ctcBreakdownData;

  return (
    <ComponentContainer>
      {ctcData.fixed.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<CashIcon size="medium" color="surface.icon.onSea.onSubtle" />}
            iconBackground={'surface.background.sea.subtle'}
            title={'Fixed'}
            description={'An earning component is any part of a salary that adds to your income'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.fixed} />
          </ComponentSectionItem>
        </ComponentSection>
      )}

      {ctcData.variable.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<PettyCashBudgetIcon size="medium" color="surface.icon.primary.normal" />}
            iconBackground={'surface.background.primary.subtle'}
            title={'Variable'}
            description={
              'Component which is based on performance, its not part of your monthly payment'
            }
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.variable} showMonthlyColumn={false} />
          </ComponentSectionItem>
        </ComponentSection>
      )}

      {ctcData.otherCtc.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<BillIcon size="medium" color="surface.icon.gray.normal" />}
            iconBackground={'surface.background.gray.intense'}
            title={'Other CTC component'}
            description={'Component part of CTC but does not include fixed and variable'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.otherCtc} showMonthlyColumn={false}/>
          </ComponentSectionItem>
        </ComponentSection>
      )}
    </ComponentContainer>
  );
};

export default CtcComponent;
